(function () {
  function getCurrentVariantId() {
    const urlVariant = new URLSearchParams(window.location.search).get('variant');

    if (urlVariant) {
      return urlVariant;
    }

    const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');

    if (variantInput && variantInput.value) {
      return variantInput.value;
    }

    return null;
  }

  function updateVariantDescriptions() {
    const currentVariantId = getCurrentVariantId();

    if (!currentVariantId) return;

    const wrappers = document.querySelectorAll('[data-variant-description-wrapper]');

    wrappers.forEach(function (wrapper) {
      const descriptions = wrapper.querySelectorAll('[data-variant-description]');

      descriptions.forEach(function (description) {
        if (description.dataset.variantDescription === currentVariantId) {
          description.hidden = false;
        } else {
          description.hidden = true;
        }
      });
    });
  }

  function delayedUpdate() {
    setTimeout(updateVariantDescriptions, 50);
    setTimeout(updateVariantDescriptions, 150);
    setTimeout(updateVariantDescriptions, 300);
  }

  document.addEventListener('DOMContentLoaded', updateVariantDescriptions);

  document.addEventListener('change', delayedUpdate);
  document.addEventListener('input', delayedUpdate);
  document.addEventListener('click', delayedUpdate);

  document.addEventListener('variant:change', delayedUpdate);
  document.addEventListener('variant:changed', delayedUpdate);
  document.addEventListener('variant-change', delayedUpdate);

  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  history.pushState = function () {
    originalPushState.apply(this, arguments);
    delayedUpdate();
  };

  history.replaceState = function () {
    originalReplaceState.apply(this, arguments);
    delayedUpdate();
  };

  window.addEventListener('popstate', delayedUpdate);

  const observer = new MutationObserver(delayedUpdate);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['value', 'checked', 'selected']
  });

  updateVariantDescriptions();
})();